import type { ActiveModel } from '@alt-point/active-models/src'
export * from './Web'
export { arrayDiff, arrayIntersect } from './Array'
export * from './Async'

const separator: string = '/'

export const slashNormalize = (path: string = '') => {
  const normalized = (path + separator).replaceAll(/([^:]\/)\/+/g, '$1')
  return normalized.endsWith('/') ? normalized.slice(0, -1) : normalized
}

export const makePrefixTag = (pathNamespace: string = '') => {
  return (
    _template: TemplateStringsArray,
    ...strings: ReadonlyArray<string>
  ) => {
    const pathComponents = [pathNamespace]
    _template.forEach((component, idx) => {
      return pathComponents.push(component, strings[idx] || '')
    }, [])

    return slashNormalize(
      pathComponents
        .map((s) => {
          s = s.trim()
          return s
        })
        .filter(Boolean)
        .join(separator),
    )
  }
}

export type DeepReadonly<T> = {
  readonly [P in keyof T]: DeepReadonly<T[P]>;
}

export function deepObjectFreeze<T extends Record<string, unknown>>(
  value: T,
): DeepReadonly<T> {
  Object.freeze(value)

  if (value === undefined) {
    return value as DeepReadonly<T>
  }

  Object.getOwnPropertyNames(value).forEach(function (prop) {
    const nestedValue = value[prop]

    if (
      nestedValue !== null
      && (typeof nestedValue === 'object' || typeof nestedValue === 'function')
      && !Object.isFrozen(nestedValue)
    ) {
      deepObjectFreeze(nestedValue as Record<string, unknown>)
    }
  })

  return value as DeepReadonly<T>
}

export class ModelSetters {
  static emptyValuePlaceholder(emptyValue: any) {
    return (m: ActiveModel, p: string, v: any, r?: ActiveModel) => {
      return Reflect.set(m, p, v || emptyValue, r)
    }
  }

  static file(emptyValue: any) {
    return (m: ActiveModel, p: string, v: any, r?: ActiveModel) => {
      const isFile = v instanceof File || v instanceof Blob
      const isArrayFile
        = Array.isArray(v)
          && v.every(item => item instanceof File || item instanceof Blob)
      return Reflect.set(m, p, isFile || isArrayFile ? v : emptyValue, r)
    }
  }
}

export function isNotPrimitive<T extends object>(value: any): value is T {
  return value && typeof value === 'object'
}

/**
 *
 * @param size
 * @returns {string}
 */
export function sizeStringOrNum(size: string | number): string {
  if (typeof size === 'string') {
    const _regExp: RegExp = new RegExp(UNITS_MEASUREMENT_STR_EXP)
    if (_regExp.test(size)) {
      return size
    }
  }

  return size + 'px'
}

export const UNITS_MEASUREMENT_STR_EXP
  = 'px|pt|em|%|rem|vh|vw|svh|lvh|dvh|svw|lvw|dvw'
/**
 * @param val
 */
export const validateUnitsMeasurement = (val: string | number): boolean => {
  if (typeof val === 'string') {
    const _regExp: RegExp = new RegExp(`^\\d+(${UNITS_MEASUREMENT_STR_EXP})$`)
    return _regExp.test(val)
  }
  if (typeof val === 'number') {
    return !isNaN(val)
  }
  return false
}
